import { gql } from '@apollo/client';

export const CREATE_PROVIDER = gql`
  mutation CreateProvider($input: CreateProviderInput!, $logo: Upload) {
    createProvider(input: $input, logo: $logo) {
      id
      name
      city
      country
      email
      type
      ownership
      logoUrl
      createdAt
    }
  }
`;

export const UPDATE_PROVIDER = gql`
  mutation UpdateProvider($id: Int!, $input: UpdateProviderInput!, $logo: Upload, $images: [Upload!]) {
    updateProvider(id: $id, input: $input, logo: $logo, images: $images) {
      id
      name
      city
      country
      state
      postalCode
      address
      description
      yearFounded
      type
      website
      email
      phone
      linkedin
      x
      ownership
      category
      languages
      degreeTypes
      logoUrl
      createdAt
    }
  }
`;